"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostUpdate = void 0;
const _1 = require(".");
function PostUpdate({ spaceId, content, hidden }) {
    return {
        spaceId: (0, _1.OptionEntity)(spaceId),
        content: (0, _1.OptionIpfsContent)(content),
        hidden: (0, _1.OptionEntity)(hidden)
    };
}
exports.PostUpdate = PostUpdate;
